import axios from './api.request'
import httpNew from './httpNew'

import configData from './conf.js'
const HTTPURL = 'https://txdfmock.test.xdf.cn/mock/68d389708cbe180027fb35a3/activityMarketing'
// 获取课程信息
export const getMarketInfo = (activityId) => {
  let data = {
    activityId: activityId
  }
  return axios.request({
    url: '/market/v1/web/market/info',
    params: data,
    method: 'GET'
  })
}

// 获取营销纬度
export const getMarketDimension = (data) => {
  return axios.request({
    url: '/market/v1/web/market/dimension',
    params: data,
    method: 'GET'
  })
}

// 获取班级列表
export const getMarketClassList = (data) => {
  return axios.request({
    url: '/market/v1/web/market/classListOnNoLive',
    params: data,
    method: 'GET'
  })
}

// 记录用户渠道
export const recordChannel = (data) => {
  return axios.request({
    url: '/market/v1/web/channel/add',
    params: data,
    method: 'GET'
  })
}

// 获取高端班级列表
export const getHighEndClassList = (data) => {
  return axios.request({
    url: '/market/v1/web/market/getHighEndClassList',
    params: data,
    method: 'GET'
  })
}

// 缓存信息
// 获取课程信息
export const getNewMarketInfo = (activityId) => {
  let data = {
    activityId: activityId
  }
  return axios.request({
    url: '/market/v1/web/info',
    params: data,
    method: 'GET'
  })
}







// 加入购物车
export const addCartApi = (data) => {
  return axios.request({
    url: `${configData.bm}/web_reg_uapi/cart/add`,
    method: 'POST',
    data,
  })
}

// 获取购物车列表
export const getCartCountApi = (data) => {
  console.log('******-----数量', data)
  return axios.request({
    url: `${configData.bm}/web_reg_uapi/cart/getCount`,
    method: 'GET',
    params: data
  })
}

// 下单前检查订单组
export const checkOrderGroup = (data) => {
  return axios.request({
    url: `${configData.bm}/web_reg_uapi/order/checkOrderGroup`,
    method: 'POST',
    data:{
      appId:'xdfmobileApp',
      ...data
    },
  })
}



// 获取学员列表 - 新接口
export const getStudentListV3 = (params) => {
  return httpNew({
    url: `${configData.HTTPURL}/api/usercenter/student/v3/student/list`,
    method: 'GET',
    params,
  })
}

// 记录用户渠道
export const getGan = (data) => {
  return axios.request({
    url: '/market/v1/web/channel/get',
    params: data,
    method: 'GET'
  })
}

// 添加优惠计算接口 - 使用 JSON 格式
export const calculatePreferential = (data) => {
  return axios.request({
    url: '/api/preferential/precomputation/class-simple',
    data: data,  // 直接传递 JSON 对象
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    }
  });
}
// 获取礼品规则
export const getGiftRules = (activityId) => {
  return axios.request({
    url: '/market/v1/web/rule/buy-gift/get',
    method: 'GET',
    params: {
      activityId: activityId
    }
  })
}

// 获取筛选数据
export const getGeneralFilter = (params) => {
  return httpNew({
    url: `${configData.HTTPURL}/market/v1/web/general/filter`,
    method: 'POST',
    data: params,
    withCredentials: true,
   
  })
}

// 获取班级列表（筛选后）
export const getClassListByFilter = (params) => {
  return httpNew({
    url: `${configData.HTTPURL}/market/v1/web/general/filter/class/list`,
    method: 'POST',
    data: params,
    withCredentials: true,
  })
}

// 获取套餐列表（筛选后）
export const getPackageListByFilter = (params) => {
  return httpNew({
    url: `${configData.HTTPURL}/market/v1/web/general/filter/package/list`,
    method: 'POST',
    data: params,
    withCredentials: true,
  })
}

// 获取默认学员
export const getDefaultStudent = () => {
  return axios.request({
    url: `${configData.HTTPURL}/api/usercenter/student/v3/default-student/get`,
    method: 'GET'
  })
}

// 获取筛选条件下的班级数量
export const getFilterClassCount = (params) => {
  return httpNew({
    url: `${configData.HTTPURL}/market/v1/web/general/filter/class-count`,
    method: 'POST',
    data: params,
    withCredentials: true,
  })
}

// 通过学校id获取城市信息
export const getCityBySchoolId = (schoolId) => {
  return httpNew({
    url: `${configData.HTTPURLDSAPI}/base/v1/city-organization/list`,
    method: 'GET',
    params: {
      schoolId: schoolId
    }
  })
}
